import Rover from '@rover/globals/Rover';
import $ from '@rover/globals/jquery';

Rover.utils = Rover.utils || {};

function init() {
  /**
   * Set up safe to use scroll and resize events
   * @see - http://ejohn.org/blog/learning-from-twitter/
   */

  const $window = $(window);

  // Fire scroll event max once every 150ms
  $window.on(
    'scroll',
    _.throttle(() => {
      $window.trigger('safeScroll');
    }, 150)
  );

  // Fire resize event only after resizing has stopped for 250ms
  $window.on(
    'resize',
    _.debounce(() => {
      $window.trigger('safeResize');
    }, 250)
  );

  initializeGATrackingEvents();
}

function recordClickEventHandler() {
  const event_name = $(this).attr('data-record-click-event');
  if (event_name) {
    dataLayer.push({
      event: 'record-event',
      event_name,
    });
  }
}

Rover.utils.initGAEvents = function(parentEl) {
  if (_.isUndefined(parentEl) || $(parentEl).length == 0) {
    return;
  }

  parentEl = $(parentEl)[0]; // allow both normal and jquery elements

  // search for all data-track-event dom elements and register their events
  const events = parentEl.querySelectorAll('[data-track-event]');
  [].forEach.call(events, el => {
    const dataset = el.dataset;

    if (dataset) {
      $(el).on(dataset.eventType, evt => {
        let eventMerge = {};
        if (dataset.eventMerge) {
          try {
            eventMerge = JSON.parse(dataset.eventMerge);
          } catch (err) {
            window.Raven.captureException(`Data Event Merge Error: ${err}`);
          }
        }
        dataLayer.push(_.extend({ event: dataset.event }, eventMerge));
      });
    }
  });
};

function initializeGATrackingEvents() {
  Rover.utils.initGAEvents(document);
}

export default {
  init,
  recordClickEventHandler,
  initializeGATrackingEvents,
};



// WEBPACK FOOTER //
// ../utilities/events.js